// extracted by mini-css-extract-plugin
module.exports = {"newsList":"_1hHg1","newsListItem":"_3iiQe","fadeIn":"_1ess4","newsListItemLink":"_16w69","newsTitle":"_1V7l3","skeleton":"UWXnE","loading":"_2oM78","loadingDesktop":"_3qujB"};